(()=>{const root=document.body.dataset.root||'/';const path=suffix=>root.replace(/\/?$/,'/')+suffix;const drawer=document.getElementById('CartDrawer');let toastTimer;let cartCloseTimer;let bagFeedbackTimer;
// Show the automatic cart introduction just once per browser. Manual cart opens still work.
const cartIntroStorageKey='cg-v1-cart-intro-shown';
let cartIntroShown=false;
try{cartIntroShown=localStorage.getItem(cartIntroStorageKey)==='1'}catch{}

function popBagIcon(){
  const icon=document.querySelector('.bag-link');
  if(!icon||document.body.dataset.motion!=='true'||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return false;
  clearTimeout(bagFeedbackTimer);
  icon.classList.remove('cg-bag-feedback');
  void icon.offsetWidth;
  icon.classList.add('cg-bag-feedback');
  bagFeedbackTimer=setTimeout(()=>icon.classList.remove('cg-bag-feedback'),1050);
  return true;
}
function flyProductToBag(form){
  if(document.body.dataset.motion!=='true'||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return false;
  const icon=document.querySelector('.bag-link');
  const picture=form.closest('.product-card')?.querySelector('.product-image img')
    ||form.closest('#CGQuickAddDialog')?.querySelector('[data-quick-add-image]:not([hidden])')
    ||form.closest('[data-product-section]')?.querySelector('.main-media img');
  if(!icon||!picture||!picture.currentSrc&&!picture.src)return false;
  const source=picture.getBoundingClientRect(),target=icon.getBoundingClientRect();
  if(source.width<15||source.height<15||source.bottom<0||source.top>innerHeight)return false;
  if(target.width<10||target.height<10)return false;
  try{
    const size=60,startX=source.left+source.width/2-size/2,startY=source.top+source.height/2-size/2;
    const endX=target.left+target.width/2-size/2,endY=target.top+target.height/2-size/2;
    const clone=document.createElement('img');
    clone.className='cg-flying-product';clone.alt='';clone.setAttribute('aria-hidden','true');
    clone.src=picture.currentSrc||picture.src;
    clone.style.left=startX+'px';clone.style.top=startY+'px';
    document.body.appendChild(clone);
    const dx=endX-startX,dy=endY-startY;
    const anim=clone.animate([
      {transform:'translate3d(0,0,0) scale(1)',opacity:.95,offset:0},
      {transform:'translate3d('+dx*.38+'px,'+(dy*.38-35)+'px,0) scale(.88)',opacity:.98,offset:.48},
      {transform:'translate3d('+dx+'px,'+dy+'px,0) scale(.24)',opacity:.15,offset:1}
    ],{duration:520,easing:'cubic-bezier(.28,.65,.32,1)',fill:'forwards'});
    anim.finished.catch(()=>{}).then(()=>clone.remove());
    return true;
  }catch{return false}
}
function notify(message){const el=document.querySelector('.toast');if(!el)return;el.textContent=message;el.classList.add('show');clearTimeout(toastTimer);toastTimer=setTimeout(()=>el.classList.remove('show'),4000)}async function refreshCart(){const response=await fetch(path('?sections=cg-cart-drawer'),{headers:{Accept:'application/json'}});if(!response.ok)throw Error(document.body.dataset.error);const sections=await response.json();if(!sections['cg-cart-drawer'])throw Error(document.body.dataset.error);document.querySelector('[data-cart-body]').innerHTML=sections['cg-cart-drawer'];const cart=await fetch(path('cart.js')).then(r=>r.json());document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count)}function closeCart(){if(!drawer?.open)return;clearTimeout(cartCloseTimer);if(document.body.dataset.motion==='false'||window.matchMedia('(prefers-reduced-motion: reduce)').matches){drawer.close();return}drawer.classList.add('closing');cartCloseTimer=setTimeout(()=>{drawer.close();drawer.classList.remove('closing')},290)}function openCart(recentlyAdded=false){if(drawer&&!drawer.open){clearTimeout(cartCloseTimer);drawer.classList.remove('closing');drawer.showModal();document.documentElement.style.overflow='hidden'}if(drawer&&recentlyAdded){drawer.classList.remove('cg-cart-added');void drawer.offsetWidth;drawer.classList.add('cg-cart-added');setTimeout(()=>drawer.classList.remove('cg-cart-added'),950)}}
function openCartIntroOnce(){
  if(!drawer||drawer.open||cartIntroShown)return false;
  openCart(true);
  if(!drawer.open)return false;
  cartIntroShown=true;
  try{localStorage.setItem(cartIntroStorageKey,'1')}catch{}
  return true;
}if(drawer){drawer.addEventListener('close',()=>document.documentElement.style.overflow='');drawer.addEventListener('click',event=>{if(event.target===drawer&&event.clientX<drawer.getBoundingClientRect().left)closeCart()})}document.addEventListener('click',async event=>{
const pageAction=event.target.closest('[data-cart-page-change]');
if(pageAction){
  event.preventDefault();
  const page=pageAction.closest('[data-cart-page]');
  const row=pageAction.closest('[data-cart-page-line]');
  if(!page||!row||page.dataset.updating==='true')return;
  const original=Number(row.dataset.lineQuantity);
  const step=Number(row.dataset.lineStep)||1;
  const min=Number(row.dataset.lineMin)||1;
  const max=Number(row.dataset.lineMax)||Infinity;
  const action=pageAction.dataset.cartPageChange;
  let quantity=original;
  if(action==='increase')quantity=Math.min(max,original+step);
  if(action==='decrease')quantity=Math.max(min,original-step);
  if(action==='remove')quantity=0;
  if(quantity===original)return;
  page.dataset.updating='true';
  page.setAttribute('aria-busy','true');
  page.querySelectorAll('[data-cart-page-change]').forEach(button=>button.disabled=true);
  const note=page.querySelector('#CartNote')?.value;
  const sectionId=page.dataset.cartSection;
  const rowIndex=Array.from(page.querySelectorAll('[data-cart-page-line]')).indexOf(row);
  try{
    const response=await fetch(path('cart/change.js'),{
      method:'POST',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({
        id:row.dataset.lineKey,
        quantity,
        sections:[sectionId],
        sections_url:path('cart')
      })
    });
    const updatedCart=await response.json();
    if(!response.ok)throw Error(updatedCart.description||updatedCart.message||document.body.dataset.error);
    document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=updatedCart.item_count);
    const html=updatedCart.sections?.[sectionId];
    if(!html){location.reload();return}
    const doc=new DOMParser().parseFromString(html,'text/html');
    const fresh=doc.querySelector('[data-cart-page]');
    if(!fresh){location.reload();return}
    const freshNote=fresh.querySelector('#CartNote');
    if(freshNote&&note!==undefined)freshNote.value=note;
    page.replaceWith(fresh);
    const focusButton=fresh.querySelectorAll('[data-cart-page-line]')[rowIndex]?.querySelector('[data-cart-page-change="'+action+'"]');
    if(focusButton&&!focusButton.disabled)focusButton.focus({preventScroll:true});
  }catch(error){
    const alert=page.querySelector('.cg-cart-page-alert');
    if(alert){alert.textContent=error.message||document.body.dataset.error;alert.hidden=false}
    else notify(error.message||document.body.dataset.error);
    page.dataset.updating='false';
    page.removeAttribute('aria-busy');
    page.querySelectorAll('[data-cart-page-change]').forEach(button=>button.disabled=false);
    const qty=Number(row.dataset.lineQuantity);
    if(qty<=min)row.querySelector('[data-cart-page-change="decrease"]')?.setAttribute('disabled','');
    if(qty>=max)row.querySelector('[data-cart-page-change="increase"]')?.setAttribute('disabled','');
  }
  return;
}
const cartAction=event.target.closest('[data-cart-change]');
if(cartAction&&drawer?.open){
  event.preventDefault();
  const row=cartAction.closest('[data-cart-line]');
  if(!row||row.dataset.updating==='true')return;
  const quantity=Number(row.dataset.lineQuantity);
  const min=Number(row.dataset.lineMin)||1;
  const step=Number(row.dataset.lineStep)||1;
  const max=Number(row.dataset.lineMax)||Infinity;
  let target=quantity;
  if(cartAction.dataset.cartChange==='increase')target=Math.min(max,quantity+step);
  if(cartAction.dataset.cartChange==='decrease')target=Math.max(min,quantity-step);
  if(cartAction.dataset.cartChange==='remove')target=0;
  if(target===quantity)return;
  row.dataset.updating='true';row.setAttribute('aria-busy','true');
  row.querySelectorAll('button').forEach(button=>{button.disabled=true});
  try{
    const response=await fetch(path('cart/change.js'),{
      method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({id:row.dataset.lineKey,quantity:target})
    });
    const cartData=await response.json();
    if(!response.ok)throw Error(cartData.description||cartData.message||document.body.dataset.error);
    await refreshCart();
  }catch(error){
    notify(error.message||document.body.dataset.error);
    try{await refreshCart()}catch{
      row.removeAttribute('aria-busy');row.dataset.updating='false';
      row.querySelectorAll('button').forEach(button=>{button.disabled=false});
    }
  }
  return;
}
const buyNow=event.target.closest('[data-buy-now]');
if(buyNow){
  event.preventDefault();
  const form=buyNow.closest('form[data-add-form]');
  if(!form||buyNow.disabled)return;
  const status=form.querySelector('.form-message');
  if(status)status.textContent='';
  buyNow.disabled=true;buyNow.setAttribute('aria-busy','true');
  try{
    const response=await fetch(path('cart/add.js'),{
      method:'POST',body:new FormData(form),headers:{Accept:'application/json'}
    });
    const item=await response.json();
    if(!response.ok)throw Error(item.description||item.message||document.body.dataset.error);
    window.location.assign(path('checkout'));
  }catch(error){
    if(status)status.textContent=error.message||document.body.dataset.error;
    else notify(error.message||document.body.dataset.error);
    buyNow.disabled=false;buyNow.removeAttribute('aria-busy');
  }
  return;
}
const close=event.target.closest('[data-close]');if(close){const dialog=close.closest('dialog');if(dialog===drawer)closeCart();else dialog?.close();return}const cartLink=event.target.closest('[data-cart-open]');if(cartLink&&drawer?.showModal){event.preventDefault();try{await refreshCart();openCart()}catch{location.href=cartLink.href}return}const thumb=event.target.closest('[data-gallery-src]');if(thumb){const img=document.getElementById('MainProductImage');if(img){event.preventDefault();img.removeAttribute('srcset');img.src=thumb.dataset.gallerySrc;img.alt=thumb.querySelector('img')?.alt||''}}});document.addEventListener('submit',async event=>{const form=event.target;if(!form.matches('[data-add-form]')||!window.fetch)return;event.preventDefault();const button=form.querySelector('button[type="submit"],button:not([type])');if(button?.disabled)return;if(button)button.disabled=true;const message=form.querySelector('.form-message');if(message)message.textContent='';try{const response=await fetch(path('cart/add.js'),{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});const result=await response.json();if(!response.ok)throw Error(result.description||result.message||document.body.dataset.error);const flew=flyProductToBag(form);const optionsDialog=form.closest('#CGQuickAddDialog');if(optionsDialog?.open)optionsDialog.close();notify(document.body.dataset.added);try{await refreshCart();const iconPopped=popBagIcon();if(!cartIntroShown&&!drawer?.open){if(iconPopped||flew)await new Promise(resolve=>setTimeout(resolve,270));openCartIntroOnce()}}catch{location.href=path('cart')}}catch(error){if(message)message.textContent=error.message;else notify(error.message)}finally{if(button)button.disabled=false}});document.addEventListener('change',async event=>{if(event.target.matches('[data-sort]')){event.target.form.requestSubmit();return}if(!event.target.matches('[data-option-select]'))return;const section=event.target.closest('[data-product-section]');const values=[...section.querySelectorAll('[data-option-select]')].map(el=>el.value).join(',');const url=new URL(section.dataset.productUrl,location.origin);url.searchParams.set('option_values',values);url.searchParams.set('section_id',section.dataset.productSection);section.setAttribute('aria-busy','true');const focusedId=event.target.id;try{const response=await fetch(url);if(!response.ok)throw Error(document.body.dataset.error);const html=new DOMParser().parseFromString(await response.text(),'text/html');const replacement=html.getElementById(section.id);if(!replacement)throw Error(document.body.dataset.error);section.replaceWith(replacement);url.searchParams.delete('section_id');history.replaceState({},'',url);document.getElementById(focusedId)?.focus({preventScroll:true});window.Shopify?.PaymentButton?.init()}catch{url.searchParams.delete('section_id');location.href=url}});document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.mobile-menu[open],.filter-details[open]').forEach(el=>el.removeAttribute('open'))});})();
